<h2 mat-dialog-title>IP-adres verificatie</h2>

<mat-dialog-content>
  <p>Je IP-adres is gewijzigd. We hebben een verificatiecode per sms verstuurd. Voer de code hieronder in.</p>

  @if (data?.ipAddress; as ipAddress) {
    <p style="margin: 0 0 12px; font-size: 0.875rem; color: rgba(0,0,0,0.6);">Huidig IP-adres: <strong>{{ ipAddress }}</strong></p>
  }

  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Verificatiecode</mat-label>
    <input matInput [(ngModel)]="verificationCode" [disabled]="loading" (keyup.enter)="submitForm()" autocomplete="off" />
  </mat-form-field>

  @if (errorMessage) {
    <p style="color: red; margin: 0 0 8px;">{{ errorMessage }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()" [disabled]="loading">Annuleren</button>
  <button mat-raised-button color="primary" (click)="submitForm()" [disabled]="loading || !verificationCode.trim()">
    @if (loading) {
      <mat-spinner diameter="20" style="display: inline-block;"></mat-spinner>
    } @else {
      Bevestigen
    }
  </button>
</mat-dialog-actions>
